import React from 'react';
import PropTypes from 'prop-types';
import Article from '~/containers/ArticleContainer/ArticleContainer';
import StyledComponent from '~/components/Styled/Styled';
import FacebookPageBox from '~/components/FacebookPageBox/FacebookPageBox';
import Ad, { AdTypes } from '~/containers/AdContainer/AdContainer';

import masonry from '~/static/css/masonry.css';
import css from '~/components/MatchupArticle/MatchupArticle.scss';

class MatchupArticle extends React.PureComponent {
  render() {
    return (
      <div>
        <div className="row">
          <div className={`col-sm-8 ${css.column}`}>
            <Article article={this.props.article} currentCard />
          </div>

          <div className={`col-sm-4 ${css.desktopView} ${css.column}`}>
            <FacebookPageBox />
            <Ad leagueSlug={this.props.event.league.slug} adType={AdTypes.BIGBOX_DESKTOP} />
          </div>
        </div>
      </div>
    );
  }
}

MatchupArticle.propTypes = {
  event: PropTypes.object.isRequired,
  article: PropTypes.object.isRequired,
};

MatchupArticle.displayName = 'MatchupArticle';

export default StyledComponent(MatchupArticle, [css, masonry]);
